import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../api';
import { useAuth } from './AuthContext';

const WishlistContext = createContext(null);
const KEY = 'bb_wishlist_v1';
const readLocal = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; } };

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState(readLocal);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (!user) { setProducts([]); return; }
    const local = readLocal();
    const req = local.length ? api.put('/wishlist', { product_ids: local }) : api.get('/wishlist');
    req.then(r => { setIds(r.data.product_ids); setProducts(r.data.products); localStorage.removeItem(KEY); }).catch(() => {});
  }, [user]);

  useEffect(() => {
    if (!user) localStorage.setItem(KEY, JSON.stringify(ids));
  }, [ids, user]);

  const has = useCallback((pid) => ids.includes(pid), [ids]);

  const toggle = async (product) => {
    const pid = product.id;
    const adding = !ids.includes(pid);
    setIds(prev => adding ? [...prev, pid] : prev.filter(i => i !== pid));
    if (user) {
      try {
        const r = adding ? await api.post(`/wishlist/${pid}`) : await api.delete(`/wishlist/${pid}`);
        setIds(r.data.product_ids); setProducts(r.data.products);
      } catch {}
    }
    return adding;
  };

  return (
    <WishlistContext.Provider value={{ ids, products, has, toggle, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
